import { Link } from "react-router-dom";
import blogPosts from "../data/blogData";
import "./BlogPage.css";

export default function BlogPage() {
  return (
    <div className="blog-page">

      {/* HERO */}
      <div className="page-hero blog-hero">
        <div className="page-hero-content">
          <div className="eyebrow" style={{ justifyContent: "center" }}>
            <div className="eline"></div>
            <span className="etxt">Stories from Albania</span>
            <div className="eline"></div>
          </div>
          <h1>Travel Blog</h1>
          <p>Stories, guides and inspiration from Albania</p>
        </div>
      </div>

      {/* GRID */}
      <div className="blog-body container">
        <div className="blog-grid">
          {blogPosts.map(function (post) {
            return (
              <Link to={"/blog/" + post.slug} key={post.id} className="blog-card">
                <div className="blog-card-img">
                  <img src={post.image} alt={post.title} />
                  <span className="blog-card-category">{post.category}</span>
                </div>
                <div className="blog-card-body">
                  <h2>{post.title}</h2>
                  <p>{post.intro}</p>
                  <div className="blog-card-footer">
                    <span className="blog-date">{post.date}</span>
                    <span className="blog-read">{post.readTime}</span>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>

    </div>
  );
}
